<template>
    <div v-if="visible" class="detail-container">
        <div class="detail-header d-flex flew-row p-1 justify-content-center align-items-center">
            <img :src="require('@/assets/img/devices/'+icon+'.png')">
            <p class="m-0 ms-1">{{ plate }}</p>
        </div>
        <table class="detail-body d-flex flex-column">
            <tr>
                <th v-for="(item, index) in columns" :key="index">
                    <p class="name m-0 fw-bold fs-6">{{ item.name }}</p>
                    <p class="value m-0 fs-6">{{ item.value }}</p>
                </th>
            </tr>
        </table>
    </div>
</template>
    
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({})
export default class ReportDetail extends Vue {
    @Prop(String) readonly icon!: string
    @Prop(String) readonly plate!: string
    @Prop(Boolean) readonly visible!: boolean
    @Prop(Array) readonly columns!: { name: string, value: string }[]
}

</script>

<style lang="sass" scoped>
@import '@/assets/style/variables.sass'
.detail-container
    position: fixed
    z-index: 999
    background: $secondary
    bottom: 72px
    width: 60%
    border: 2px solid #fff
    border-radius: 5px
    .detail-header
        img
            height: 35px
        p
            color: #fff
            font-size: 19px
        
    .detail-body
        background: #fff
        
        .name
            color: $secondary
        tr
            border: 2px solid $secondary
            border-radius: 0px 0px 5px 5px
            border-collapse: collapse
            border-top: 0px
            th
                padding: 2px 10px
                width: 100%
                border: 2px solid $secondary
                border-collapse: collapse
    
</style>
    